import React, { useEffect, useState } from 'react'
import './widget.scss'
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'; 
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import FlightIcon from '@mui/icons-material/Flight';
import { collection, where, query, getDocs, onSnapshot } from 'firebase/firestore'
import { sum, getAggregateFromServer, } from "@firebase/firestore";
import { db } from '../../firebase'
import { Link } from "react-router-dom";



const Widget= ({type}) => {

  const [diff, setDiff] = useState(null);
  const [applicant, setApplicant] = useState(0)
  const [application, setApplication] = useState(0)
  const [datas, setDatas ] = useState([])
  const [total, setTotal] = useState(0)
  const [totalNaira, setTotalNaira] = useState(0)
  const [totalUSD, setTotalUSD] = useState(0)

  
  let data;

  switch(type){
    case "applicants":
      data={
        title:"TOTAL APPLICANTS",
        isMoney:false,
        link:"see all applicants",
        page:"/applicants",
        amount: applicant,
        icon:<
          PersonOutlineOutlinedIcon className="icon" 
          style={{
          color:"crimson",
          backgroundColor: "rgba(255, 0, 0, 0.2)"
        }}/>,
      }
      break;
      case "applications":
        data={
          title:"TOTAL VISA APPLICATIONS",
          isMoney:false,
          link:"view all applications",
          page:"/applications",
          amount: application,
          icon:<
          FlightIcon className="icon"
            style={{
              color:"goldenrod",
              backgroundColor: "rgba(218, 165, 32, 0.2)"
            }}
            />,
        }
        break;

        case "dollar":
          data={
            title:"TOTAL IN DOLLAR",
            isMoney:true,
            link:"view net earnings in Dollar",
            page:"/dollarPayments",
            currency:"USD",
            amount: totalUSD ,
            icon:<MonetizationOnOutlinedIcon className="icon"
            style={{
              color:"green",
              backgroundColor: "rgba(0, 128, 0, 0.2)"
            }}/>,
          }
          break;
          
        case "naira":
          data={
            title:"TOTAL IN NAIRA",
            isMoney:true,
            link:"view net earnings in Naira",
            page:"/nairaPayments",
            currency:"NGN",
            amount: totalNaira,
            icon:<AccountBalanceWalletOutlinedIcon className="icon"
            style={{
              color:"purple",
              backgroundColor: "rgba(128, 0, 128, 0.2)"
            }}
          />,
        }
        break;
      default:
      break
  }


  useEffect(() => {

    //LISTEN REAL TIME
    
        const collectionRef = collection(db, "visa")
    
        const unsub = onSnapshot(collectionRef, (snapShot) => {
          let list = [];
          // let total = 0
          
          snapShot.docs.forEach((doc) => {
            list.push(doc.data())
            // list.push({price:doc.data().price})
          })
          setDatas(list)
         
          }, 
            (error) => {
              console.log(error)
            }
          );
      
          return () => {
            unsub();
          }
      
    //END LISTEN REAL TIME    
    
  },[])

  console.log('Data info: ',datas)


  const formatWithCommas = (amountInput) => {
    // 1. Force convert string input to a clean number
    const cleanInput = typeof amountInput === 'string' 
      ? amountInput.replace(/[^0-9.-]+/g, "") 
      : amountInput;
      
    const numericAmount = parseFloat(cleanInput);
  
    // 2. Handle invalid inputs gracefully
    if (isNaN(numericAmount)) {
      return '0.00';
    }
  
    // 3. Use 'decimal' style to strip out symbols
    return new Intl.NumberFormat('en-US', {
      style: 'decimal', 
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  };


  useEffect(() => {

//LISTEN REAL TIME

    const collectionRef = collection(db, "visa")

    const r = query(collectionRef, where("constant", "==", 'active'), where("currency", "==", "USD"));

    const unsub = onSnapshot(r, (snapShot) => {
      let list = [];
      // let total = 0
      
      snapShot.docs.forEach((doc) => {
        list.push({total:doc.data().total})
      })
      // setDatas(list)
      // const earning = list.reduce((tot, currentValue) => tot = tot + currentValue.total,0);
     const earning = list.reduce((tot, currentValue) => {
            // Explicitly parse values to prevent string concatenation or NaN issues
            const value = typeof currentValue.total === 'string' 
              ? parseFloat(currentValue.total) 
              : currentValue.total;
            return tot + (isNaN(value) ? 0 : value);
          }, 0);
     
      setTotalUSD(earning)
      }, 
        (error) => {
          console.log(error)
        }
      );
  
      return () => {
        unsub();
      }
  
//END LISTEN REAL TIME    

  },[])



  useEffect(() => {
    
        const collectionRef = collection(db, "visa")

        const r = query(collectionRef, where("constant", "==", 'active'), where("currency", "==", "NGN"));
  
    
        const unsub = onSnapshot(r, (snapShot) => {
          let list = [];
          // let total = 0
          
          snapShot.docs.forEach((doc) => {
            list.push({total:doc.data().total})
          })
          // setDatas(list)
          // const earning = list.reduce((tot, currentValue) => tot = tot + currentValue.total,0);
          const earning = list.reduce((tot, currentValue) => {
            // Explicitly parse values to prevent string concatenation or NaN issues
            const value = typeof currentValue.total === 'string' 
              ? parseFloat(currentValue.total) 
              : currentValue.total;
            return tot + (isNaN(value) ? 0 : value);
          }, 0);
          setTotalNaira(earning)
          }
          , 
            (error) => {
              console.log(error)
            }
          );
      
          return () => {
            unsub();
          }
      
    //END LISTEN REAL TIME    
    
  },[])

    
  // console.log('total: ', total)



  useEffect(() => {
    const fetchData = async() => {
      const today = new Date();
      const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1))
      const prevMonth = new Date(new Date().setMonth(today.getMonth() - 2))
      console.log('last month:', lastMonth)
      console.log('previous month:', prevMonth)
      console.log('today:', today)

      const lastMonthQuery = query(
        collection(db, "visa"), 
        where("timeStamp", "<=", today),
        where("timeStamp", ">", lastMonth)
      );
      const prevMonthQuery = query(
        collection(db, "visa"), 
        where("timeStamp", "<=", lastMonth),
        where("timeStamp", ">", prevMonth)
      );

      

      const travellersQuery = collection(db, "travellers")
      const allTravellers = await getDocs(travellersQuery)
      setApplicant(allTravellers.docs.length)

      const visaQuery = collection(db, "visa")
      const allVisa = await getDocs(visaQuery)
      setApplication(allVisa.docs.length)

 
      const lastMonthData = await getDocs(lastMonthQuery)
      const prevMonthData = await getDocs(prevMonthQuery)

    
      setDiff((lastMonthData.docs.length - prevMonthData.docs.length) / (prevMonthData.docs.length) * 100)
        
    };

    fetchData();

  }, [])

   

  return (
        <div className='widget'>
          <div className="left">
            <span className="title">{data.title}</span>
            <span className="counter" to>
            {data.isMoney && data.currency === 'NGN' ? '₦' : data.currency === 'USD' ? '$' : ""}{data.isMoney ? formatWithCommas(data.amount) : data.amount}
 
            </span>
            <Link to={data.page} className='page'>
            <span className="link">{data.link}</span>
            </Link>
          </div>
          <div className="right">
            <div className="percentage positive">
              <KeyboardArrowUpOutlinedIcon/>
            </div>
            {data.icon}
          </div>
        </div>
      )

}

export default Widget


// import './widget.scss'
// import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
// import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'; import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
// import { collection, where, query, getDocs, onSnapshot } from 'firebase/firestore'
// import { db } from '../../firebase'
// import { Link } from "react-router-dom";

// const Widget= ({type}) => {

//   const [diff, setDiff] = useState(null);
//   const [applicant, setApplicant] = useState(null)
//   const [application, setApplication] = useState(null)
//   const [datas, setDatas ] = useState([])
//   const [total, setTotal] = useState(null)


  
//   let data;

//   switch(type){
//     case "applicants":
//       data={
//         title:"APPLICANTS",
//         isMoney:false,
//         link:"see all applicants",
//         page:"/applicants",
//         amount: applicant,
//         icon:<
//           PersonOutlineOutlinedIcon className="icon" 
//           style={{
//           color:"crimson",
//           backgroundColor: "rgba(255, 0, 0, 0.2)"
//         }}/>,
//       }
//       break;
//       case "application":
//         data={
//           title:"APPLICATIONS",
//           isMoney:false,
//           link:"view all applications",
//           page:"/applications",
//           amount: application,
//           icon:<
//             ShoppingCartOutlinedIcon className="icon"
//             style={{
//               color:"goldenrod",
//               backgroundColor: "rgba(218, 165, 32, 0.2)"
//             }}
//             />,
//         }
//         break;

//       case "earning":
//         data={
//           title:"EARNINGS",
//           isMoney:true,
//           link:"view net earnings",
//           page:"/earnings",
//           amount: total ,
//           icon:<MonetizationOnOutlinedIcon className="icon"
//           style={{
//             color:"green",
//             backgroundColor: "rgba(0, 128, 0, 0.2)"
//           }}/>,
//         }
//         break;
        
//       case "balance":
//         data={
//           title:"BALANCE",
//           isMoney:true,
//           link:"see details",
//           page:"/balance",
//           amount: applicant,
//           icon:<AccountBalanceWalletOutlinedIcon className="icon"
//           style={{
//             color:"purple",
//             backgroundColor: "rgba(128, 0, 128, 0.2)"
//           }}
//           />,
//         }
//         break;
//       default:
//       break
//   }


//   useEffect(() => {

//     //LISTEN REAL TIME
    
//         const collectionRef = collection(db, "application")
    
//         const unsub = onSnapshot(collectionRef, (snapShot) => {
//           let list = [];
//           // let total = 0
          
//           snapShot.docs.forEach((doc) => {
//             list.push({price:doc.data().price})
//           })
//           setDatas(list)
//           const earning = list.reduce((tot, currentValue) => tot = tot + currentValue.price,0);
//           setTotal(earning)
//           }, 
//             (error) => {
//               console.log(error)
//             }
//           );
      
//           return () => {
//             unsub();
//           }
      
//     //END LISTEN REAL TIME    
    
//       },[])

    

//     // console.log('earning:', earning);

//     console.log(datas);
//     console.log(total);

//     // const users = [{ name: 'Tom', age: 21}, { name: 'Mike', age: 23}, { name: 'Anna', age: 54}]

//     // const getAverageAge = (datas) => {
//     //   let sum = 0
//     //   for (let i = 0; i < datas.length; i++) {
//     //     sum += datas[i].price
//     //   }
//     //   return sum
      
//     // }
  
//     //   getAverageAge(datas) 



      

    
    

//     // console.log('sum:', sum);



//   useEffect(() => {
//     const fetchData = async() => {
//       const today = new Date();
//       const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1))
//       const prevMonth = new Date(new Date().setMonth(today.getMonth() - 2))
//       console.log(lastMonth)
//       console.log(prevMonth)

//       const lastMonthQuery = query(
//         collection(db, "applicants"), 
//         where("timeStamp", "<=", today),
//         where("timeStamp", ">", lastMonth)
//       );
//       const prevMonthQuery = query(
//         collection(db, "applicants"), 
//         where("timeStamp", "<=", lastMonth),
//         where("timeStamp", ">", prevMonth)
//       );

//       const customerQuery = collection(db, "applicants")
//       const allCustomer = await getDocs(customerQuery)
//       setApplicant(allCustomer.docs.length)

//       const orderQuery = collection(db, "application")
//       const allOrder = await getDocs(orderQuery)
//       setApplication(allOrder.docs.length)


//       // const collectionRef = collection(db, "application")
    
    
//       const lastMonthData = await getDocs(lastMonthQuery)
//       const prevMonthData = await getDocs(prevMonthQuery)

    
//       setDiff((lastMonthData.docs.length - prevMonthData.docs.length) / (prevMonthData.docs.length) * 100)

//       // let timestamp = '1452488445471';
//       // let newDate = new Date(timestamp * 1000)
//       // let thisDay = new Date(timeStamp)
//       // let thisDate = thisDay.toLocaleString()
//       // let Hours = thisDay.getHours()
//       // let Minutes = thisDay.getMinutes()
//       // let HourComplete = Hours + ':' + Minutes
//       // let formatedTime = HourComplete
//       // console.log(thisDay)
//       // console.log(formatedTime)
//       // console.log(thisDate)
//       // console.log(thisDay)
//       // console.log(today)
        
//     };


















// import React, { useEffect, useState } from 'react'
// import './widget.scss'
// import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
// import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'; 
// import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
// import { collection, where, query, getDocs, onSnapshot, getAggregateFromServer, sum } from 'firebase/firestore'
// import { db } from '../../firebase'
// import { Link } from "react-router-dom";

// const Widget= ({type}) => {

//   const [users, setUsers] = useState(null)
//   const [subscribers, setSubscribers] = useState(null)
//   const [outlets, setOutlets] = useState(null)
//   const [earnings, setEarnings] = useState(null)
//   const [diff, setDiff] = useState(null);
//   const [datas, setDatas ] = useState([])
//   const [total, setTotal] = useState(null)
//   // const [riders, setRiders] = useState(null)
//   // const [drivers, setDrivers] = useState(null)
//   // const [rides, setRides] = useState(null)
//   // const [deliveries, setDeliveries] = useState(null)
  

//   let data;

//   switch(type){
//     case "users":
//       data={
//         title:"ALL USERS",
//         isMoney:false,
//         link:"see all customers",
//         page:"/customers",
//         amount: users,
//         icon:<
//           PersonOutlineOutlinedIcon className="icon" 
//           style={{
//           color:"crimson",
//           backgroundColor: "rgba(255, 0, 0, 0.2)"
//         }}/>,
//       }
//        break;
//        case "subscribers":
//         data={
//           title:"ALL SUBSCRIBERS",
//           isMoney:false,
//           link:"see all subscribers",
//           page:"/subscribers",
//           amount: subscribers,
//           icon:<
//             PersonOutlineOutlinedIcon className="icon" 
//             style={{
//             color:"crimson",
//             backgroundColor: "rgba(255, 0, 0, 0.2)"
//           }}/>,
//         }

//         break;
      
//         case "outlets":
//           data={
//             title:"ALL OUTLETS",
//             isMoney:false,
//             link:"view all outlet",
//             page:"/outlets",
//             amount: outlets ,
//             icon:<MonetizationOnOutlinedIcon className="icon"
//             style={{
//               color:"green",
//               backgroundColor: "rgba(0, 128, 0, 0.2)"
//             }}/>,
//           }

//         break;
      
//       case "earnings":
//         data={
//           title:"ALL EARNINGS",
//           isMoney:true,
//           link:"view earnings",
//           page:"/payments",
//           amount: earnings ,
//           icon:<MonetizationOnOutlinedIcon className="icon"
//           style={{
//             color:"green",
//             backgroundColor: "rgba(128, 0, 128, 0.2)"
//           }}/>,
//         }
//         break;
        
//       // case "balance":
//       //   data={
//       //     title:"TOTAL BALANCE",
//       //     isMoney:true,
//       //     link:"see details",
//       //     page:"/balance",
//       //     amount: riders,
//       //     icon:<AccountBalanceWalletOutlinedIcon className="icon"
//       //     style={{
//       //       color:"purple",
//       //       backgroundColor: "rgba(128, 0, 128, 0.2)"
//       //     }}
//       //     />,
//       //   }
//       //   break;
//       default:
//       break
//   }


//   useEffect(() => {

//     //LISTEN REAL TIME

   
           
//         const collectionRef = collection(db, "subscribers")
    
//         const unsub = onSnapshot(collectionRef, (snapShot) => {
//           let list = [];
          
//           snapShot.docs.forEach((doc) => {
//             list.push({amount:doc.data().amount})
//           })
//           setDatas(list)
//           const earning = list.reduce((tot, currentValue) => tot = tot + currentValue.amount, 0);
//           const options = {  maximumFractionDigits: 2   }   
//           const formattedNumber = Intl.NumberFormat("en-US",options).format(earning); 
//           setEarnings(formattedNumber)
//           }, 
//             (error) => {
//               console.log(error)
//             }
//           );
      
//           return () => {
//             unsub();
//           }
      
//     //END LISTEN REAL TIME    
    
//   },[])


//   useEffect(() => {

//     const fetchData = async() => {
//       const today = new Date();
//       const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1))
//       const prevMonth = new Date(new Date().setMonth(today.getMonth() - 2))
//       console.log(lastMonth)
//       console.log(prevMonth)


//     //   const todayQuery = query(
//     //   collection(db, "subscribers"), 
//     //   where("timeStamp", "==", today)
//     // );

//     //   const todayData = await getDocs(todayQuery)
//     //   setSubscribers(subscribersData.docs.length)

//       // const lastMonthQuery = query(
//       //   collection(db, "rides"), 
//       //   where("timeStamp", "<=", today),
//       //   where("timeStamp", ">", lastMonth)
//       // );
//       // const prevMonthQuery = query(
//       //   collection(db, "rides"), 
//       //   where("timeStamp", "<=", lastMonth),
//       //   where("timeStamp", ">", prevMonth)
//       // );
      

//       // db.collection("users")
//       // .onSnapshot((snapshot) => {
//       //     // ...
//       // }, (error) => {
//       //     // ...
//       // });



//       const usersQuery = collection(db, "users")
//       const allUsers = await getDocs(usersQuery)
//       setUsers(allUsers.docs.length)



//       const outletsQuery = collection(db, "subscribers")
//       const allOutlets = await getDocs(outletsQuery)
//       setOutlets(allOutlets.docs.length)



//       const subscribersQuery = query(
//         collection(db, "users"), 
//         where("subscribed", "==", true),
//       );
//       const subscribersData = await getDocs(subscribersQuery)
//       setSubscribers(subscribersData.docs.length)

    
//     };

//     fetchData();

//   }, [])

//   return (
//     <div className='widget'>
//       <div className="left">
//         <span className="title">{data.title}</span>
//         <span className="counter" to>
//           {data.isMoney && 'N'}
//           {data.amount}
//         </span>
//          <Link to={data.page} className='page'>
//         <span className="link">{data.link}</span>
//         </Link> 
//       </div>
//       <div className="right">
//         <div className="percentage positive">
//           <KeyboardArrowUpOutlinedIcon/>
//           {diff}%
//         </div>
//         {data.icon}
//       </div>
//     </div>
//   )
// }

// export default Widget